import { NotificationModel, NotificationVariant } from '../../../../types/Notification'

export type NotificationDisplayItem = {
    notification: NotificationModel
    count: number
    ids: string[]
    displayTitle?: string
}

const isSameNotificationContent = (left: NotificationModel, right: NotificationModel): boolean =>
    left.message === right.message &&
    left.title === right.title &&
    left.variant === right.variant &&
    left.actions === right.actions

const formatDisplayTitle = (title: string | undefined, count: number): string | undefined => {
    if (count < 2) {
        return title
    }

    if (title) {
        return `${title} (×${count})`
    }

    return `(×${count})`
}

/**
 * Groups open ERROR notifications with identical content (all fields except id) for display.
 * Other variants stay one-per-entry. Newest-first; a repeated error bumps its group to the top as 'newest'.
 */
export const groupNotificationsForDisplay = (notifications: NotificationModel[]): NotificationDisplayItem[] => {
    const displayItems: NotificationDisplayItem[] = []

    notifications.forEach((notificationIterator) => {
        if (notificationIterator.variant === NotificationVariant.ERROR) {
            const existingErrorGroup = displayItems.find(
                (item) =>
                    item.notification.variant === NotificationVariant.ERROR &&
                    isSameNotificationContent(item.notification, notificationIterator)
            )

            if (existingErrorGroup) {
                existingErrorGroup.ids.push(notificationIterator.id)
                existingErrorGroup.count = existingErrorGroup.ids.length
                existingErrorGroup.displayTitle = formatDisplayTitle(
                    existingErrorGroup.notification.title,
                    existingErrorGroup.count
                )
                return
            }
        }

        displayItems.push({
            notification: notificationIterator,
            count: 1,
            ids: [notificationIterator.id],
            displayTitle: notificationIterator.title,
        })
    })

    return displayItems
}
